import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

export const Route = createFileRoute("/docs")({
  component: DocsLayout,
});

function DocsLayout() {
  return (
    <>
      <Header />
      <div className="docs-wrap">
      <aside className="docs-side">
        <div className="sgroup">
          <h6>Getting started</h6>
          <Link to="/docs" activeOptions={{ exact: true }}>
            Overview
          </Link>
          <Link to="/docs/quickstart">Quickstart</Link>
          <Link to="/docs/how-it-works">How it works</Link>
        </div>
        <div className="sgroup">
          <h6>Frameworks</h6>
          <Link to="/docs/nextjs">Next.js</Link>
          <Link to="/docs/tanstack-start">TanStack Start</Link>
        </div>
        <div className="sgroup">
          <h6>Reference</h6>
          <Link to="/docs/api-reference">API reference</Link>
        </div>
      </aside>
      <main className="docs-content">
        <Outlet />
      </main>
      </div>
      <Footer />
    </>
  );
}
